import { warn } from "@swivl-mono/helpers";
import {
  APIScope,
  Channel,
  DoesSessionHaveActiveEscalation,
  EscalationInterface,
  IsSessionTakenOver,
  SessionInterface,
  UserInterface
} from "@swivl-mono/types";
import { Button, ButtonColor } from "@swivl-mono/ui";

import { ShowIf } from "../../../../../../Components/ShowIf/ShowIf";
import { ChannelColors } from "../../../../../../Helpers/Conversations/Conversations.Helper";
import useHasPendingUpdates from "../../../../../../Hooks/useHasPendingUpdates";
import { Member } from "../../../../../../Models/Member/Member.Current";
import MembersModel from "../../../../../../Models/Member/Members.Model";
import { PendingUpdateType } from "../../../../../../Models/Pending/Pending.Model";
import { UserConversationsInterface, UsersModel } from "../../../../../../Models/Users/Users.Model";

interface ChatFooterTakenOverProps {
  user: UserInterface;
  conversation?: UserConversationsInterface;
  channel: Channel;
  currentChannelColor: (typeof ChannelColors)[Channel];
  session?: SessionInterface;
}
export function ChatFooterNotTakenOverComponent(props: ChatFooterTakenOverProps) {
  const { conversation, channel, currentChannelColor, session, user } = props;
  const escalation = conversation?.sessions?.[channel]?.escalation as EscalationInterface | undefined;
  console.log("VCB ChatFooterNotTakenOverComponent:", conversation, channel, escalation);
  const membersMap = MembersModel.useState((state) => state.membersMap);
  const hasPendingUpdates = useHasPendingUpdates([
    { type: PendingUpdateType.SESSION_ESCALATION, id: session?.id || "none" },
    { type: PendingUpdateType.TAKING_OVER_ON_CHANNEL, id: channel }
  ]);

  console.log("hasPendingUpdates :", hasPendingUpdates);

  /* Scenarios:
  1) Session is not taken over. Chat.
  2) Session has escalation and it is pending / assigned to someone else.
  3) Session has escalation and it is assigned to me.
  4) Session has escalation and taken over by another agent.
  */
  const handleTakeover = () => {
    if (user) {
      UsersModel.takeoverConversationOnChannel(user.id, channel);
    } else {
      warn("No escalation found for this conversation.", conversation, session, escalation);
    }
  };

  const acceptEscalation = () => {
    if (escalation) {
      UsersModel.acceptEscalation(escalation);
    } else {
      warn("No escalation found for this conversation.", conversation);
    }
  };
  const ignoreEscalation = () => {
    if (escalation) {
      UsersModel.ignoreEscalation(escalation);
    } else {
      warn("No escalation found for this conversation.", conversation);
    }
  };

  const isSessionTaken = IsSessionTakenOver(session);
  const doesSessionHaveActiveEscalation = DoesSessionHaveActiveEscalation(session);

  let actionText = channel === Channel.VOICE ? "This customer is on a call with" : "This customer is chatting with";
  let currentAgentName = "the automated bot.";
  let buttons = (
    <ShowIf scope={APIScope.CONVERSATION_TAKEOVER}>
      <Button color={currentChannelColor.buttonColor} loading={hasPendingUpdates} onClick={handleTakeover}>
        Takeover
      </Button>
    </ShowIf>
  );

  // scenario 1 - conversation is archived
  if (user.isArchived) {
    actionText = "This conversation is closed. Reopen it to take over.";
    currentAgentName = "";
    buttons = <></>;
  }

  if (!doesSessionHaveActiveEscalation) {
    // scenario 2 - no action needed?
  } else if (doesSessionHaveActiveEscalation) {
    if (!isSessionTaken) {
      if (escalation?.assignedMemberId !== Member.id) {
        console.log("PUF (escalation?.assignedMemberId !== Member.id :", escalation?.assignedMemberId, Member.id);
        // scenario 3
        actionText = "This customer is waiting for another agent.";
        currentAgentName = "";
      } else {
        // scenario 4
        actionText = "This customer is assigned to you.";
        currentAgentName = "";
        buttons = (
          <div className="flex space-x-3">
            <Button color={ButtonColor.LIGHT_GREY} loading={hasPendingUpdates} onClick={ignoreEscalation}>
              Reject
            </Button>
            <Button color={currentChannelColor.buttonColor} loading={hasPendingUpdates} onClick={acceptEscalation}>
              Accept
            </Button>
          </div>
        );
      }
    } else {
      // scenario 5
      currentAgentName =
        membersMap && escalation?.assignedMemberId && membersMap[escalation?.assignedMemberId].agentName
          ? membersMap[escalation.assignedMemberId].agentName!
          : "another agent.";
      buttons = <></>;
    }
  }

  return (
    <div className="flex flex-col items-center justify-center gap-2 py-4 text-center">
      <span className="italic">
        {actionText} {currentAgentName}
      </span>
      {buttons}
    </div>
  );
}
